/** Presents every fallback destination when one KPI creates several non-brand DataViews. */
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, Typography} from "@mui/material";
import {DataType} from "@michaeltoft/c2s-statistics-dashboard";
import type {DrilldownResult} from "@michaeltoft/c2s-statistics-dashboard";
import {drilldownTypeLabel} from "./DashboardDrilldownRouting";

interface DashboardDrilldownDestinationsProps {
   targets: DrilldownResult[];
   onClose: () => void;
   onOpen: (target: DrilldownResult) => void;
}

/** Lets the operator choose a generated list without discarding sibling DataViews. */
export const DashboardDrilldownDestinations = ({
   targets,
   onClose,
   onOpen
}: DashboardDrilldownDestinationsProps) => <Dialog
   open={targets.length > 0}
   onClose={onClose}
   aria-labelledby="dashboard-drilldown-destinations-title"
   maxWidth="xs"
   fullWidth
>
   <DialogTitle id="dashboard-drilldown-destinations-title">Choose what to view</DialogTitle>
   <DialogContent>
      <Typography variant="body2" color="text.secondary" sx={{mb: 2}}>
         This figure created more than one useful cohort.
      </Typography>
      <Stack spacing={1}>
         {targets.map(target => <Button
            key={target._id}
            variant="outlined"
            disabled={!target.url && target.dataType !== DataType.Branditems}
            onClick={() => onOpen(target)}
            sx={{justifyContent: "space-between"}}
         >
            <span>{drilldownTypeLabel(target.dataType)}</span>
            {!target.url && target.dataType !== DataType.Branditems && <span>No destination available</span>}
         </Button>)}
      </Stack>
   </DialogContent>
   <DialogActions>
      <Button onClick={onClose}>Cancel</Button>
   </DialogActions>
</Dialog>;
